import './index.scss';
import React, { useRef } from 'react';
import { Link } from 'gatsby';
import { Swiper, SwiperSlide } from 'swiper/react';
import ArrowButton from '../ArrowButton';
import HoverCubeAnimation from '../HoverCubeAnimation';
import useSlider from '../../hooks/useSlider';

const ProjectSlider = ({ projects, title }) => {
  const swiperRef = useRef(null);
  const { onInit, isEnd, isBeginning, nextSlide, prevSlide, handleDrag } = useSlider(swiperRef);

  const options = {
    slidesPerView: 'auto',
    freeMode: true,
    centeredSlides: false,
    spaceBetween: 12,
    breakpoints: {
      630: { slidesPerView: 1 },
      1000: { slidesPerView: 2 },
      1300: { slidesPerView: 5 },
    }
  };

  return (
    <div className="project-slider" >
      <div className="container">
        <h2 className="project-slider__headline">{title}</h2>
      </div>
      <Swiper {...options} onBeforeInit={onInit} onSlideChange={handleDrag}>
        {projects.map((slide, outerIndex) => (
          <SwiperSlide key={outerIndex} virtualIndex={outerIndex}>
            <div className={`project-slider__slide ${slide.images.length > 1 ? 'project-slider__slide--multicol' : ''}`}>
              {slide.images.map((project, innerIndex) => (
                <div
                  key={`${outerIndex}${innerIndex}`}
                  style={{ display: 'block' }}
                  className="project-slider__item"
                >
                  <HoverCubeAnimation
                    key={innerIndex}
                    speed={600}
                    front={
                      <img src={project.image} className='project-slider__image' alt='' loading='lazy' />
                    }
                    back={
                      <>
                        {project.link && !project.link.match(/^https?/) && (
                          <Link
                            to={project.link || ''}
                            className="project-slider__text"
                          >
                            {project.text}
                          </Link>
                        )}
                        {project.link && project.link.match(/^https?/) && (
                          <a
                            href={project.link}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="project-slider__text"
                          >
                            {project.text}
                          </a>
                        )}
                        {!project.link && (
                          <div className="project-slider__text">
                            {project.text}
                          </div>
                        )}
                      </>
                    }
                  />
                </div>
              ))}
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
      <div className="project-slider__bottom">
        <a
          className="button button--color-black button--color-black--ref"
          href="/projekte"
        >
          Alle Projekte
        </a>
        <div className="project-slider__button-wrapper">
          <ArrowButton
            full
            onClick={prevSlide}
            mods={isBeginning ? ['left', 'color-blue', 'disable'] : ['left', 'color-blue']}
            ariaLabel='Zurück'
          />
          <ArrowButton
            full
            onClick={nextSlide}
            mods={isEnd ? ['right', 'color-blue', 'disable'] : ['right', 'color-blue']}
            ariaLabel='Weiter'
          />
        </div>
      </div>
    </div>
  );
};

export default ProjectSlider;
